import { connect } from 'react-redux'
import TaxAreaComponent from '../../components/profile/valttiCard.component'
import {
  getIndustryTaxCard,
  shipbuildingTaxCard,
  closeSnackbar
} from '../../actions'

/**
 * Valtticard container KAS.335
 *
 * @author Huong Nguyen
 */

const mapStateToProps = (state) => {
  return {
    state,
    taxInfo: state.industryTaxArea.taxInfo,
    taxFormValues: state.industryTaxArea.formValues,
    isSnackbar: state.industryTaxArea.isSnackbar,
    isFailedSnackbar: state.industryTaxArea.isFailedSnackbar
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getIndustryTaxCard: (userData) => dispatch(getIndustryTaxCard(userData)),
    shipbuildingTaxCard: (formValues) =>
      dispatch(shipbuildingTaxCard(formValues)),
    closeSnackbar: () => dispatch(closeSnackbar())
  }
}

const ValttiCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxAreaComponent)

export default ValttiCardContainer
